import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 仓储查询操作要求
export function queryOperationRequirementAll(params) {
  return request({
    url: URL.booking.airExport.queryOperationRequirementAll,
    method: 'get',
    params: params
  })
}

// 查询操作要求
export function queryOperationRequirement(data) {
  return request({
    url: URL.booking.airExport.queryOperationRequirement,
    method: 'post',
    data
  })
}

// 更新操作要求状态
export function updateOperationRequirementState(form) {
  const data = new FormData()
  for (const key in form) {
    data.append(key, form[key])
  }
  return request({
    url: URL.booking.airExport.updateOperationRequirementState,
    method: 'post',
    data
  })
}
